import { CmsValidityComponent } from '@spa/top-level-components/cms-page/metadata/CmsValidityComponent';
import MagnoliaCmsValidationComponent from '@spa/top-level-components/cms-page/metadata/magnolia/dynamic-magnolia-cms-validity.component';

function DefaultCmsValidityComponent(): null {
  return null;
}

const ConfigurableCmsValidity: CmsValidityComponent =
  process.env.NEXT_PUBLIC_CMS_METADATA_RENDER === 'magnolia'
    ? MagnoliaCmsValidationComponent
    : DefaultCmsValidityComponent;

export default ConfigurableCmsValidity;
